var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJohncube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.932 51.9188C79.9271 54.0305 77.9662 55.3379 76.1512 55.3379C75.4903 55.3379 74.8567 55.1814 74.2672 54.8721L43.4421 38.705C42.2832 38.0972 41.5615 36.9659 41.5581 35.7524L41.4839 3.47437C41.4819 2.55733 41.8693 1.69977 42.5729 1.06103C43.2855 0.413326 44.2674 0.041954 45.2647 0.041954C45.9221 0.041954 46.5543 0.19722 47.1418 0.504597L78.1101 16.6686C79.2794 17.2783 80.0033 18.4164 79.9999 19.6384L79.932 51.9188Z",
    fill: "url(#paint0_linear_2_123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.628 38.6701L5.65782 54.8328C5.07035 55.1401 4.43881 55.2954 3.78077 55.2954C2.78347 55.2954 1.80293 54.924 1.08892 54.2763C0.385354 53.6369 -0.00210406 52.78 8.59424e-06 51.863L0.0741419 19.585C0.0769394 18.3713 0.798693 17.2401 1.95817 16.6324L32.7833 0.465771C33.3729 0.157139 34.0065 -3.8147e-05 34.6673 -3.8147e-05C36.4822 -3.8147e-05 38.4433 1.3074 38.4481 3.41904L38.518 35.7003C38.5208 36.9222 37.7963 38.0598 36.6275 38.6708L36.628 38.6701Z",
    fill: "url(#paint1_linear_2_123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7311 63.3809C73.9109 62.7624 74.6158 61.6539 74.6151 60.4181C74.6144 59.1816 73.9073 58.0756 72.7261 57.4578L41.7738 41.2875C41.2011 40.9884 40.5499 40.8306 39.8891 40.8306C39.2261 40.8306 38.5736 40.9896 38.0001 41.2894L7.15345 57.4495C5.9722 58.068 5.26728 59.1766 5.26871 60.413C5.26941 61.6495 5.97647 62.7559 7.15972 63.3739L38.1406 79.5436C38.7134 79.8427 39.3638 79.9999 40.0246 79.9999C40.6876 79.9999 41.3408 79.8408 41.9144 79.5404L72.7311 63.3809Z",
    fill: "url(#paint2_linear_2_123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_123",
    x1: 60.7419,
    y1: 55.6251,
    x2: 60.7419,
    y2: 0.0000806423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_123",
    x1: 19.0625,
    y1: 0.0000172426,
    x2: 19.0625,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_123",
    x1: 74.3751,
    y1: 60.6249,
    x2: 5.00015,
    y2: 60.6249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJohncube);
export default __webpack_public_path__ + "static/media/johncube.f3ec03353c8a098ae8ca06677090488a.svg";
export { ForwardRef as ReactComponent };